import React from 'react';
import Radium from 'radium';

import styles from './ProductStyle.js';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import MailCapture from '../../components/Mail/Mail';
import logo from '../../img/assets/optimus_logo50.png';

class Products extends React.Component {
    render() {
        return (
            <div>
                <Navbar />
                <div className="container" style={styles.container}>
                    <div className="row">
                        <div className="col-xs-12 text-center" style={{ marginBottom: 50 }}>
                            <h1 style={styles.servicesHeaderMain}>OUR PRODUCTS</h1>
                        </div>
                    </div>
                    <div className="row" style={{ marginBottom: 50 }}>
                        <div className="col-xs-12">
                            <h3 style={styles.servicesHeader}>
                                <img className="img img-responsive" style={styles.logo} alt="logo" src={logo}></img>
                                Optimus Spark
                            </h3>
                            <div>
                                <br />
                                <h4> The Challenge </h4>
                                <p>
                                    Talent is the one of the most strategic asset for any organization. Talent provides immense
                                    competitive advantage and enables profitable growth for the organization.
                                </p>
                                <p>
                                    However, talent management is extremely challenging on account of the following attributes:
                                </p>
                                <ul>
                                    <li>It needs complete participation from people</li>
                                    <li>It requires keeping pace with rapid advancement in technologies</li>
                                    <li>It has many dimensions viz. Technical, behavioral, domain and functional for each individual</li>
                                    <li>It needs strong process and tools to capture and maintain the skillset of employees for an organization</li>
                                </ul>

                                <p>Most organizations find it very difficult to get answers to the following questions:</p>
                                <ul>
                                    <li>Are my resources fit for performing the assigned responsibilities?</li>
                                    <li>Am I suffering from obsolete skills which are not suitable to meet my client needs?</li>
                                    <li>Do I have the resources to compete in near future?</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-xs-12">
                            <br />
                            <h4>The Solution</h4>
                            <p>
                                We at Optimus Spark understand the above challenges and have evolved a Talent Management platform to address them.
                            </p>
                            <p>
                                The platform deals with the complete life cycle of talent management:
                            </p>
                            <ul>
                                <li>Talent capture across multiple dimensions</li>
                                <li>Talent Assessment</li>
                                <li>Gap Analysis</li>
                                <li>Talent Development</li>
                            </ul>
                        </div>
                        <div className="col-xs-12 col-md-10" style={{ marginBottom: 30, marginTop: 50 }}>
                            <MailCapture />
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}

export default Radium(Products);


// WEBPACK FOOTER //
// ./src/containers/Products/Products.js